import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from 'react';
import { IconButton, Box, Grid, styled, useTheme, Collapse, Badge, } from '@mui/material';
import ViewHeadlineIcon from '@mui/icons-material/ViewHeadline';
import { Text } from '../../atoms/typography';
import ExpandCollapse from '../../atoms/ExpandCollapse';
import Stepper from '../../molecules/Stepper';
import HeaderDataCell from '../../molecules/HeaderDataCell';
import { EnvironmentBanner } from '../../atoms/EnvironmentBanner';
import useMediaQueries from '../../../hooks/useMediaQueries';
import PageHeaderContainer from '../../atoms/PageHeaderContainer';
const Cell = styled(Grid) `
  display: flex;
  height: 100%;
`;
const ModuleTitleCell = styled(Cell) `
  flex: 1;
  padding: 4px 16px;
  &.desktop {
    padding: 8px 16px;
  }
`;
const HeaderTitle = styled(Text) `
  font-size: 20px;
  font-weight: 700;
`;
const TitleIconBox = styled(Grid, {
    shouldForwardProp: prop => prop !== 'moduleColor',
}) `
  svg {
    width: .70em;
    height: .70em;
    path {
      color: white;
    }
  }
  display: flex;
  padding: 5px;
  border-radius: 50%;
  margin-right: 16px;
  background-color: ${({ moduleColor, theme }) => moduleColor || theme.palette.modules.default || theme.palette.action.active};
  &.desktop {
    padding: 12px;
    svg {
      width: 1em;
      height: 1em;
    }
  }
`;
const MenuButton = styled(IconButton) `
  margin-right: 12px;
  color: black;
`;
const Header = ({ pageHeader = null, title, icon = undefined, data = {}, currentStep = undefined, steps = [], skippedSteps = [], moduleColor, onClickMenu, environment, alertLevel, }) => {
    const theme = useTheme();
    const { fitForDesktop, fitForMobile, mediaClassNames } = useMediaQueries();
    const [isExpanded, setIsExpanded] = useState(true);
    const dataCells = Object.entries(data).map(([key, { title, value, action }]) => (_jsx(HeaderDataCell, { title: title, value: value, action: action }, key)));
    const shouldShowStepper = steps.length > 1 && currentStep;
    const stepper = (_jsx(Stepper, { steps: steps.map(step => ({ ...step, moduleColor })), currentStep: currentStep, skippedSteps: skippedSteps }));
    const handleMenuButtonClick = (event) => {
        onClickMenu(event);
    };
    return (_jsx(_Fragment, { children: _jsxs(Grid, { item: true, container: true, className: "Header", display: "flex", flexDirection: "column", width: "100%", sx: {
                position: 'sticky',
                top: '0',
                zIndex: theme.zIndex.appBar,
                overflowX: 'clip',
                overflowY: 'visible', // temporary stepper responsivity fix for mobile devices
                backgroundColor: theme.palette.background.paper,
            }, children: [environment && (_jsx(Grid, { item: true, container: true, borderBottom: `1px solid ${theme.palette.divider}`, children: _jsx(EnvironmentBanner, { environment: environment }) })), _jsx(Box, { className: 'wrapper', overflow: 'clip', children: _jsx(Collapse, { in: isExpanded, children: _jsxs(Box, { width: '100vw', children: [_jsxs(Grid, { item: true, container: true, borderBottom: shouldShowStepper || pageHeader ? `2px solid ${theme.palette.divider}` : undefined, bgcolor: 'grey.50', flexDirection: fitForMobile ? 'column' : 'row', wrap: 'nowrap', children: [_jsxs(ModuleTitleCell, { item: true, container: true, display: 'flex', alignItems: 'center', justifyContent: 'start', className: mediaClassNames, children: [_jsx(MenuButton, { onClick: handleMenuButtonClick, children: _jsx(Badge, { variant: "dot", color: alertLevel, invisible: !alertLevel, children: _jsx(ViewHeadlineIcon, {}) }) }), icon && (_jsx(TitleIconBox, { item: true, moduleColor: moduleColor, className: mediaClassNames, children: icon })), _jsx(HeaderTitle, { children: title })] }), dataCells] }), shouldShowStepper && (_jsx(Grid, { container: true, alignItems: 'center', justifyContent: 'space-between', bgcolor: 'background.paper', borderBottom: pageHeader ? `2px solid ${theme.palette.divider}` : undefined, minWidth: '700px' // temporary responsivity fix for mobile devices
                                    , children: _jsx(Grid, { item: true, container: true, paddingX: 'var(--standard-spacing-x, 24px)', paddingY: fitForDesktop ? '16px' : '10px', flex: 1, children: stepper }) })), pageHeader &&
                                    _jsx(PageHeaderContainer, { children: pageHeader })] }) }) }), _jsx(ExpandCollapse, { isExpanded: isExpanded, onExpandCollapse: () => setIsExpanded(prev => !prev), color: !pageHeader && !shouldShowStepper ?
                        theme.palette.trove.offWhite.main :
                        theme.palette.background.paper })] }) }));
};
export default Header;
//# sourceMappingURL=index.js.map